var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('h5',[_vm._v("※ 한국아스텔라스제약")]),_c('p',[_vm._v(" 주소: 서울시 강남구 테헤란로 521 파르나스타워 7층"),_c('br'),_vm._v(" 대표 번호: 02-3448-0504 "),_c('br'),_vm._v(" 업무 시간: 월요일~금요일: 오전 9:00~오후 6:00(토요일과 일요일, 법정 공휴일과 회사 창립 기념일 휴무)"),_c('br')])])
}]

export { render, staticRenderFns }